/**
 * Created by Sandon on 2019-05-08.
 */
export const defaultProps = {
  key: 'id',
  label: 'label',
  children: 'children',
  disabled: 'disabled',
  isLeaf: 'isLeaf',
  completeLabel: 'completeLabel' // todo selector使用
}
let id = 0

export default class Node {
  constructor (options) {
    this._isTreeNode = true
    this.id = id++
    this.options = options
    this.level = options.level || 0
    this.data = options.data
    this.parent = options.parent
    this.singleAndNotMustLeaf = options.singleAndNotMustLeaf || false
    this.props = options.props
    this.labelDivider = options.labelDivider

    // 把data对象中的数据抽出来，并增加$treeNodeId
    const props = Object.assign({}, defaultProps, options.props)
    this.key = options.data && options.data[props['key']]
    if (!this.singleAndNotMustLeaf && this.level !== 0 && (this.key === null || this.key === undefined)) {
      throw new Error('key should be exist')
    }
    this.label = options.data && options.data[props['label']]
    this.completeLabel = this.parent && this.parent.completeLabel
      ? `${this.parent.completeLabel}${this.options.labelDivider}${this.label}`
      : this.label
    this.childNodes = []
    this.disabled = (options.data && options.data[props['disabled']]) || (this.parent && this.parent.disabled) || false
    this.isLeaf = (options.data && options.data[props['isLeaf']]) || false
    this.loaded = options.loaded || this.isLeaf || false

    this.data && (this.data.$treeNodeId = this.id)

    /*
     * 选中：checked: true, indeterminate: false
     * 未选：checked: false, indeterminate: false
     * 半选：checked: false, indeterminate: true
     */
    this.checked = (this.parent && this.parent.checked) || false
    this.indeterminate = false
  }
  // 根据data添加一个node child
  appendDataChild (data, options) {
    const parent = this
    const child = new Node(
      Object.assign({}, {
        level: parent.level + 1,
        data,
        parent,
        props: parent.props,
        labelDivider: parent.labelDivider
      }, options))
    parent.childNodes.push(child)
  }
}

export function checkChange (node) {
  // 注意顺序： 子孙 -> 自己 -> 祖先
  // 修改子孙的选择状态
  const checked = node.checked // 最新的状态
  let existOppositeWhenDisabled = false
  let arr = node.childNodes
  for (let i = 0; i !== arr.length; i++) {
    const curNode = arr[i]
    if (curNode.disabled) {
      if (!existOppositeWhenDisabled && curNode.checked !== checked) {
        existOppositeWhenDisabled = true
      }
    } else {
      curNode.checked = checked
      curNode.indeterminate = false
    }

    arr = arr.concat(arr[i].childNodes)
  }

  // 修改自己的状态
  node.indeterminate = existOppositeWhenDisabled // 无disabled 或 虽有但同值都相同，则false

  // 修改祖先的选中状态
  let tmp = node.parent
  while (tmp) {
    const len = tmp.childNodes.length
    let checkedCount = 0 // 选中计数
    let uncheckedCount = 0 // 未选计数（不包括半选）
    tmp.childNodes.forEach((childNode) => {
      if (childNode.checked) {
        checkedCount++
      } else if (!childNode.indeterminate) {
        uncheckedCount++
      }
    })
    if (checkedCount === len) {
      // 子级都是选中状态，自己也就选中状态
      tmp.checked = true
      tmp.indeterminate = false
    } else if (uncheckedCount === len) {
      // 子级都是未选状态，自己也就未选状态
      tmp.checked = false
      tmp.indeterminate = false
    } else {
      // 自己半选状态
      tmp.checked = false
      tmp.indeterminate = true
    }

    tmp = tmp.parent
  }
}

// 全量场景：选中keys
export function setCheckedKeys (root, keys, force = false) {
  const keysSet = new Set(keys)
  root.checked = false

  // 1、设置 checked
  let nodes = [...root.childNodes]
  for (let i = 0; i !== nodes.length; i++) {
    const node = nodes[i]
    if (!node.disabled || force) {
      node.checked = keysSet.has(node.key) || node.parent.checked
      node.indeterminate = false
    }
    nodes = nodes.concat(node.childNodes)
  }

  if (!keysSet.size) return // keys 为空数组，相当于清空

  // 2、设置 indeterminate，倒序遍历nodes，也即从下至上按层遍历树
  for (let i = nodes.length - 1; i !== -1; i--) {
    const node = nodes[i]
    const childNodes = node.childNodes
    if (!childNodes.length) {
      node.indeterminate = false
      continue
    }
    let strictCheckedCount = 0
    let strictUncheckedCount = 0
    let indeterminate = false
    const len = childNodes.length
    for (let j = 0; j !== len; j++) {
      const childNode = childNodes[j]
      if (childNode.indeterminate) {
        indeterminate = true
        break
      } else if (childNode.checked) {
        strictCheckedCount++
      } else {
        strictUncheckedCount++
      }
    }
    if (indeterminate || (strictCheckedCount && strictUncheckedCount)) {
      // 半选状态
      node.checked = false
      node.indeterminate = true
    } else if (strictCheckedCount === len) {
      // 选中
      node.checked = true
      node.indeterminate = false
    } else {
      // 未选
      node.checked = false
      node.indeterminate = false
    }
  }
}
